"use client";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import h from "../components/Icon/SvgIcon.js";
const r = (c) => /* @__PURE__ */ e(
  h,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: [
      /* @__PURE__ */ o("path", { fill: "#fff", d: "M5 5h14v14H5z" }),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
        }
      )
    ]
  }
), n = t(r);
export {
  n as CheckboxUnchecked,
  n as default
};
